import React from 'react';

/**
 * Fixed atmospheric layer: scanlines + film noise.
 * Sits above the page background but below content interaction.
 */
export default function Atmosphere() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[1]">
      <div className="absolute inset-0 scanlines" />
      <div className="absolute inset-0 noise" />
      <div
        className="absolute inset-x-0 top-0 h-px animate-scan bg-gradient-to-r from-transparent
                   via-emerald-400/30 to-transparent opacity-40 dark:opacity-70"
      />
    </div>
  );
}
